import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class ProcessService {
    constructor(http) {
        this.http = http;
        this.singular = 'process';
        this.plural = 'processes';
        this.editor = PLATFORM.moduleName('pages/standard-setup/processes/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`processes/filter/${loadOptions}`);
        return await response.json();
    }

    async create(process) {
        await this.http.fetch('processes', { method: 'POST', body: json(process) });
    }

    async update(process) {
        await this.http.fetch(`processes/${process.id}`, { method: 'PUT', body: json(process) });
    }

    async delete(id) {
        await this.http.fetch(`processes/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`processes/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`processes/top-three/${query}`);
        return await response.json();
    }
}